module.exports = __webpack_public_path__ + "media/luxury-2026/garden-architecture-960-3df25521.jpg";